import { render, staticRenderFns } from "./ComplaintPersonalSummary.vue?vue&type=template&id=e7fffd46&"
import script from "./ComplaintPersonalSummary.vue?vue&type=script&lang=js&"
export * from "./ComplaintPersonalSummary.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintPersonalSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports